export default __webpack_public_path__ + "static/hero-8181c6e9fc344dbee7424cc4583cfd86.mp4";